import { React, useState } from "react";
import { PageHeader } from "../Scheme.styled";
import { SelectField } from "../../../components/Form/FormComponents";

function SchemeHeader() {
	const [formData, setFormData] = useState({});
	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};
	return (
		<PageHeader>
			<div className='form-group'>
				<label>Scheme Owner Category</label>
				<SelectField
					handleChange={handleChange}
					name='schemeOwnerCategory'
					value={formData?.schemeOwnerCategory}
					options={["Employer", "Tier 1", "Tier 2"]}
                    isEditable={true}
				/>
			</div>
            <div className='form-group'>
				<label>Scheme Owners</label>
				<SelectField
					handleChange={handleChange}
					name='schemeOwners'
					value={formData?.schemeOwners}
					options={["Tekno", "Fotcore", "Apple"]}
                    isEditable={true}
				/>
			</div>
		</PageHeader>
	);
}

export default SchemeHeader;
